export default "__VITE_ASSET__CtTiar2p__"